export const USER_ROLE_LABELS = {
  employee: 'Сотрудник',
  student: 'Студент',
  pupil: 'Школьник',
  company: 'Внешний партнёр',
}

export const SELECTABLE_USER_ROLES = Object.keys(USER_ROLE_LABELS).map((value) => ({
  value,
  name: USER_ROLE_LABELS[value],
}))

export function isSelectableUserRole(role) {
  return Object.prototype.hasOwnProperty.call(USER_ROLE_LABELS, role)
}

export function omitUnselectedRole(payload) {
  if (!payload || typeof payload !== 'object') {
    return payload
  }
  if (isSelectableUserRole(payload.role)) {
    return payload
  }
  const next = { ...payload }
  delete next.role
  return next
}

export function sanitizeNecessaryFields(necessaryFields) {
  if (!necessaryFields || typeof necessaryFields !== 'object') {
    return necessaryFields
  }

  const fields = necessaryFields.fields
  let nextFields = fields
  let removedRole = false

  if (Array.isArray(fields)) {
    nextFields = fields.filter((field) => {
      const key = typeof field === 'string' ? field : field && (field.name || field.key || field.field)
      if (key === 'role') {
        removedRole = true
        return false
      }
      return true
    })
  } else if (fields && typeof fields === 'object' && Object.prototype.hasOwnProperty.call(fields, 'role')) {
    const rest = { ...fields }
    delete rest.role
    nextFields = rest
    removedRole = true
  }

  if (!removedRole) {
    return necessaryFields
  }

  const next = {
    ...necessaryFields,
    fields: nextFields,
  }

  const remainingCount = Array.isArray(nextFields)
    ? nextFields.length
    : nextFields && typeof nextFields === 'object'
      ? Object.keys(nextFields).length
      : 0

  if (remainingCount === 0) {
    next.redirect = false
  }

  return next
}

export function sanitizeUserFromApi(user) {
  if (!user || typeof user !== 'object' || !user.necessary_fields) {
    return user
  }
  return {
    ...user,
    necessary_fields: sanitizeNecessaryFields(user.necessary_fields),
  }
}
